import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/styles/withStyles";
// custom
import AppBar from "components/AppBar";
// reactor
import AuthChecker from "components/AuthChecker";
import EnvMessage from "components/EnvMessage";
import ForgotPassword from "components/ForgotPassword";
import KeyboardEvents from "components/KeyboardEvents";
import LeftMenu from "components/LeftMenu";
import MessageDrawer from "components/MessageDrawer";
// components
import NotificationCenter from "components/NotificationCenter";
import ResetPassword from "components/ResetPassword";
import Signup from "components/Signup";
import Upload from "components/Upload";
import UrlActions from "components/UrlActions";
import WebSocket from "components/WebSocket";
import {
  ENV_MESSAGE,
  GOOGLE_ANALYTICS_KEY,
  REACT_APP_ROOT_BACKGROUND,
} from "config";
import { DEFAULT, SIGNIN } from "constants/routes";
// helpers
import { redirectAccordingToRole } from "helpers/redirect";
import PropTypes from "prop-types";
import React from "react";
import { withCookies } from "react-cookie";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
// styles
import styles from "./styles";

class WrapperRootPage extends React.Component {
  static propTypes = {
    routes: PropTypes.array,
    allRoutes: PropTypes.array,
    cookies: PropTypes.object,
    history: PropTypes.object,
    theme: PropTypes.object,
    location: PropTypes.object,
    classes: PropTypes.object,
    user: PropTypes.object,
    userApps: PropTypes.array,
    getCurrentUser: PropTypes.func,
    signout: PropTypes.func,
    signup: PropTypes.func,
    validateEmail: PropTypes.func,
    stopImpersonate: PropTypes.func,
    requestResetPassword: PropTypes.func,
    resetPassword: PropTypes.func,
    errors: PropTypes.object,
    storeResetPasswordToken: PropTypes.func,
    setOrganizationByDefault: PropTypes.func,
    joinOrganization: PropTypes.func,
    setDarkMode: PropTypes.func,
    app: PropTypes.object,
    init: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      mobileOpen: false,
      loading: true,
      alert: null,
    };

    if (GOOGLE_ANALYTICS_KEY) {
      ReactGA.initialize(GOOGLE_ANALYTICS_KEY);
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      if (GOOGLE_ANALYTICS_KEY) {
        ReactGA.pageview(window.location.pathname + window.location.search);
      }
    }
  }

  handleDrawerToggle = () => {
    this.setState((prevState) => ({ mobileOpen: !prevState.mobileOpen }));
  };

  injectRoutes() {
    const { routes } = this.props;

    return (
      <div style={{ flexGrow: 1, display: "flex", position: "relative" }}>
        <Switch>
          {routes.map((route) =>
            route.path === DEFAULT ? (
              <Route key={route.path} component={route.component} />
            ) : (
              <Route
                key={route.path}
                path={route.path}
                component={route.component}
              />
            )
          )}
        </Switch>
      </div>
    );
  }

  render() {
    const {
      classes,
      location,
      routes,
      history,
      getCurrentUser,
      errors,
      signup,
      validateEmail,
      requestResetPassword,
      signout,
      storeResetPasswordToken,
      app,
      resetPassword,
      user,
      setDarkMode,
      userApps,
      allRoutes,
      init,
      stopImpersonate,
      setOrganizationByDefault,
      joinOrganization,
    } = this.props;

    const { loading, mobileOpen, alert } = this.state;

    const route = routes.find((r) => r.path === location.pathname);

    return (
      <div>
        <AuthChecker
          routes={allRoutes}
          history={history}
          location={location}
          user={user}
          getCurrentUser={getCurrentUser}
          onReady={() => {
            this.setState({ loading: false });
          }}
          signinRoute={SIGNIN}
          redirectAccordingToRole={redirectAccordingToRole}
          init={init}
        >
          <NotificationCenter errors={errors}>
            <WebSocket user={user}>
              <KeyboardEvents>
                <UrlActions
                  location={location}
                  history={history}
                  validateEmail={validateEmail}
                  storeResetPasswordToken={storeResetPasswordToken}
                >
                  <Signup
                    history={history}
                    signup={signup}
                    validateEmail={validateEmail}
                  >
                    <ForgotPassword
                      history={history}
                      requestResetPassword={requestResetPassword}
                    >
                      <ResetPassword
                        token={app.resetPasswordToken}
                        resetPassword={resetPassword}
                        storeResetPasswordToken={storeResetPasswordToken}
                      >
                        <Upload>
                          {loading ? (
                            <Grid
                              container
                              className={classes.loading}
                              alignContent="center"
                              alignItems="center"
                            >
                              <Grid
                                item
                                xs={12}
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <CircularProgress
                                  style={{ color: "#ffffff" }}
                                />
                              </Grid>
                            </Grid>
                          ) : (
                            <MessageDrawer
                              background={REACT_APP_ROOT_BACKGROUND}
                            >
                              <EnvMessage envMessage={ENV_MESSAGE} />
                              <div
                                style={{
                                  display: "flex",
                                  flexGrow: 1,
                                }}
                              >
                                {route && route.withSidebar && (
                                  <LeftMenu
                                    routes={routes}
                                    handleDrawerToggle={this.handleDrawerToggle.bind(
                                      this
                                    )}
                                    mobileOpen={mobileOpen}
                                    history={history}
                                    user={user}
                                    location={location}
                                  />
                                )}
                                <div
                                  style={{
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  {route && route.withAppBar && (
                                    <AppBar
                                      onMenuOpen={this.handleDrawerToggle.bind(
                                        this
                                      )}
                                      user={user}
                                      userApps={userApps}
                                      history={history}
                                      app={app}
                                      setDarkMode={setDarkMode}
                                      stopImpersonate={stopImpersonate}
                                      signout={signout}
                                      setOrganizationByDefault={
                                        setOrganizationByDefault
                                      }
                                      joinOrganization={joinOrganization}
                                      getCurrentUser={getCurrentUser}
                                    />
                                  )}
                                  {this.injectRoutes()}
                                  {alert}
                                </div>
                              </div>
                            </MessageDrawer>
                          )}
                        </Upload>
                      </ResetPassword>
                    </ForgotPassword>
                  </Signup>
                </UrlActions>
              </KeyboardEvents>
            </WebSocket>
          </NotificationCenter>
        </AuthChecker>
      </div>
    );
  }
}

export default withCookies(
  withRouter(
    connect()(withStyles(styles, { withTheme: true })(WrapperRootPage))
  )
);
